import React, { memo } from "react";
import { ButtonProps as MUIButtonProps } from "@mui/material";
import CircularProgress from "@component/circularProgress/CircularProgress";
import { StyledButtonContainer } from "./button.style";

interface ButtonProps extends MUIButtonProps {
  loading?: boolean;
  progressColor?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning"
    | undefined;
}

const Button: React.FC<ButtonProps> = ({
  loading,
  children,
  progressColor = "secondary",
  ...rest
}) => {
  return (
    <StyledButtonContainer {...rest}>
      {loading ? (
        <CircularProgress size={20} color={progressColor} />
      ) : (
        children
      )}
    </StyledButtonContainer>
  );
};

export default memo(Button);
